import * as React from 'react'
import * as css from './IndustriesServed.module.css'

const IndustriesServed = ({ title, description, industries }) => (
  <section className="bg-suede-black text-white padding">
    <div className="grid md:grid-cols-2 gap-8 ctnr">
      <div className="max-w-[470px] richtext">
        <h2 className="h0">{title}</h2>
        {description && <p>{description}</p>}
      </div>

      <ul className={css.list}>
        {industries?.map((item, key) => (
          <li className="px-4 mb-4" key={key}>{item}</li>
        ))}
      </ul>
    </div>
  </section>
)

export default IndustriesServed
